var bokun = window.bokun || {};

bokun.front = {
	init: function() {
		$('.bookButton').on('click touchstart', function(e) {
			e.preventDefault();
			var $target = $('#route__search');
			$('html, body').animate({
				scrollTop: $target.offset().top - 100
			}, 400, function() {
			});
		});
	}
};

bokun.routeView = {
	thumb: null,
	big: null,
	init: function () {
		bokun.routeView.big = site.owl.init('.route__images', {
				items: 1,
				loop: false,
				nav: true,
				navText: [
					'<i class=\'fa fa-chevron-left\' aria-hidden=\'true\'></i>',
					'<i class=\'fa fa-chevron-right\' aria-hidden=\'true\'></i>'
				]
			});
			bokun.routeView.thumb = site.owl.init('.route__imagethumbs', {
				items: 5,
				slideBy: 5,
				loop: false,
				nav: false,
			});

			$('.route__imagethumbs .owl-item:first-of-type').addClass('current');

			bokun.routeView.big.on('changed.owl.carousel', function(event) {
				bokun.routeView.syncBigWithThumb(event);
			});

			bokun.routeView.thumb.on('changed.owl.carousel', function(event) {
				bokun.routeView.syncThumbWithBig(event)
			});


		$('.route__imagethumbs').on('click', '.owl-item', function(e) {
			e.preventDefault();
			var number = $(this).index();
			bokun.routeView.big.data('owl.carousel').to(number, 300, true);
		});
	},
	syncBigWithThumb: function (event) {
		var current = event.item.index;
		bokun.routeView.thumb
			.find('.owl-item')
			.removeClass('current')
			.eq(current)
			.addClass('current');
		bokun.routeView.thumb.data('owl.carousel').to(current, 500, true);
	},
	syncThumbWithBig:function (event) {
		var number = event.item.index;
		bokun.routeView.big.data('owl.carousel').to(number, 500, true);
	}
};
